import React, { FC } from 'react';
import classnames from 'classnames';

const Item: FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  const { children, className, ...rest } = props;
  return (
    <div className={classnames('fs-list-item', className)} {...rest}>
      {children}
    </div>
  );
};

export default Item;
